<template>
  <div class="container mt-5 mb-5">
        <md-card class="text-center">
            <md-card-header>
            <div class="md-title">Validación</div>
            <div class="md-subhead">Valida que los datos esten correctos</div>
            </md-card-header>

            <md-card-content>
                <div class="row d-flex justify-content-center">
                    <div class="col-md-4">
                       <md-field>
                            <label>Cliente/Razón Social</label>
                            <md-input v-model="persona.NOMBRE_PERSONA" disabled></md-input>
                        </md-field> 
                    </div>
                    <div class="col-md-4">
                        <md-field>
                            <label>Apellido Paterno</label>
                            <md-input v-model="persona.APELLIDO_PATERNO" disabled></md-input>
                        </md-field> 
                    </div>
                    <div class="col-md-4">
                        <md-field>
                            <label>Apellido Materno</label>
                            <md-input v-model="persona.APELLIDO_MATERNO" disabled></md-input>
                        </md-field> 
                    </div>
                </div>
                <div class="row d-flex justify-content-center">
                    <div class="col-md-2">
                       <md-field>
                            <label>Póliza</label>
                            <md-input v-model="persona.NUM_POLIZA" disabled></md-input>
                        </md-field> 
                    </div>
                    <div class="col-md-2">
                        <md-field>
                            <label>Certificado</label>
                            <md-input v-model="persona.NUM_CERTIFICADO" disabled></md-input>
                        </md-field> 
                    </div>
                    <div class="col-md-6">
                        <md-field>
                            <label>Filial/Subcontratante</label>
                            <md-input v-model="persona.NOM_FILIAL" disabled></md-input>
                        </md-field> 
                    </div>
                    <div class="col-md-2">
                        <md-field>
                            <label>Núm. Renovación</label>
                            <md-input v-model="persona.NUM_RENOV_POL" disabled></md-input>
                        </md-field> 
                    </div>
                </div>
                <div class="row d-flex justify-content-center">
                    <div class="col-md-4">
                       <md-field>
                            <label>Fecha de Nacimiento</label>
                            <md-input v-model="persona.F_NACIMIENTO" disabled></md-input>
                        </md-field> 
                    </div>
                    <div class="col-md-4">
                        <md-field>
                            <label>Participación</label>
                            <md-input v-model="persona.T_ASEG" disabled></md-input>
                        </md-field> 
                    </div>
                    <div class="col-md-4">
                        <md-field>
                            <label>Vigencia Póliza Inicio</label>
                            <md-input v-model="persona.F_INI_VIGENCIA" disabled></md-input>
                        </md-field> 
                    </div>
                </div>
                <div class="row d-flex justify-content-center">
                    <div class="col-md-4">
                        <md-field>
                            <label>Vigencia Póliza Fin</label>
                            <md-input v-model="persona.F_FIN_VIGENCIA" disabled></md-input>
                        </md-field> 
                    </div>
                    <div class="col-md-3">
                       <md-field>
                            <label>Estatus de la Póliza</label>
                            <md-input v-model="persona.SIT_INCISO_POL" disabled></md-input>
                        </md-field> 
                    </div>
                    <div class="col-md-5">
                        <md-field>
                            <label>Producto</label>
                            <md-input v-model="persona.NOM_PRODUCTO" disabled></md-input>
                        </md-field> 
                    </div>
                </div>
                <div class="row d-flex justify-content-center">
                        <div class="col-md-4">
                        <md-field>
                            <label>Nivel Hospitalario</label>
                            <md-input v-model="persona.NIVEL_HOSP" disabled></md-input>
                        </md-field> 
                    </div>
                        <div class="col-md-4">
                        <md-field>
                            <label>Inciso</label>
                            <md-input v-model="persona.ID_INCISO" disabled></md-input>
                        </md-field> 
                    </div>
                </div>
                
            </md-card-content>
            <md-card-actions v-if="step">
                <md-button style="background: #9cc4e4; color: #586875;" @click="reloadPage"
                    class="md-raised col-2 m-3"><i class="fas fa-search mr-2"></i>Nueva busqueda
                </md-button>
                <md-button style="background: #9cc4e4; color: #586875;" @click="continuarRegistro"
                    class="md-raised col-3 m-3"><i class="fas fa-check mr-2"></i>Continuar registro
                </md-button>
            </md-card-actions>
        </md-card>
    </div>
</template>

<script>
export default {
    props: {
        continuarRegistro: Function,
        persona: Object,
        step: Boolean,
    },
    methods:{
        reloadPage(){
            location.reload();
        }
    }
}
</script>

<style>

</style>